import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Announcement(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Announcement", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M26.2289 37.4098c.3529-.3319.3313-.8936-.061-1.182-.5861-.431-.9965-1.0801-1.0877-1.8402-.0909-.7574.1537-1.4769.6189-2.0244l-1.3946-.8559c-.6595.8471-.9973 1.9277-.8613 3.0614.1434 1.1952.7849 2.2182 1.7025 2.9014.1577.1173.3542.1758.5533.1647.1992-.0111.3874-.091.5299-.225Zm8.1768 2.6621-8.8589 4.7998c-.1876.1049-.406.1472-.6213.1203-.2152-.0268-.4152-.1213-.5686-.2687l-.8364-.8032c-.0913-.0876-.1638-.1917-.2132-.3063-.0494-.1146-.0749-.2374-.0749-.3614s.0255-.2468.0749-.3614c.0494-.1145.1219-.2186.2132-.3063l6.7509-6.483 4.1343 3.9702Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m28.2616 11.1972-.8152-.7724-8.1227 7.6947-8.1225 7.6946.8153.7725s8.6534 1.6684 15.5128 7.1168c.5946.4723 1.47.4402 2.0187-.0796l3.071-2.9093 3.0711-2.9093c.5487-.5198.5826-1.3489.084-1.9123-5.7512-6.4982-7.5125-14.6957-7.5125-14.6957Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m42.0602 31.9976-3.9381-3.864-4.0073 3.9317-4.0074 3.9319 3.9383 3.8639c1.2526 1.2291 3.2834 1.2291 4.536 0l1.7393-1.7064 1.7391-1.7064c1.2527-1.2291 1.2527-3.2217.0001-4.4507Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m38.7064 35.5799-1.5811-1.5513c-.0914-.0928-.142-.2172-.1409-.3463.0011-.1292.0539-.2527.147-.344.093-.0913.2189-.143.3505-.1441.1316-.0011.2584.0486.353.1383l1.5809 1.5512c.0466.0457.0836.1.1088.1597s.0382.1237.0382.1884c0 .0646-.013.1287-.0382.1884s-.0622.114-.1088.1597c-.0941.0923-.2217.1441-.3547.1441s-.2606-.0518-.3547-.1441ZM14.161 12.6814l-2.4724-2.4257c-.1439-.145-.2239-.33976-.2225-.54217.0013-.20241.0838-.39615.2297-.53927.1459-.14313.3434-.22412.5497-.22544.2063-.00132.4048.07714.5525.21839l2.4724 2.42579c.1439.1449.2239.3397.2226.5421-.0014.2024-.0839.3962-.2298.5393s-.3433.2241-.5496.2254c-.2063.0014-.4049-.0771-.5526-.2184Zm10.2492-5.48122V3.76964c0-.20412.0827-.39988.2298-.54422.1471-.14433.3466-.22542.5546-.22542.1031-.00001.2051.01988.3002.05856.0952.03867.1817.09536.2545.16683.0729.07147.1307.15632.1701.24971.0394.09338.0597.19347.0597.29454v3.43054c0 .20412-.0827.39989-.2298.54422-.1471.14434-.3466.22543-.5547.22543-.208 0-.4075-.08109-.5546-.22543-.1471-.14433-.2298-.3401-.2298-.54422ZM9.63248 21.6995H6.13604c-.20805 0-.40759.0811-.55471.2254-.14712.1444-.22977.3402-.22977.5443s.08265.3999.22977.5442c.14712.1444.34666.2255.55471.2255h3.49644c.20649-.0023.40372-.0845.54892-.2286.1452-.144.2266-.3385.2266-.5411s-.0814-.3971-.2266-.5412-.34243-.2262-.54892-.2285Zm27.07242 16.362-2.1032-2.0637c-.062-.0608-.1111-.133-.1447-.2124-.0335-.0794-.0508-.1646-.0507-.2506 0-.086.0172-.1711.0508-.2506.0335-.0794.0827-.1516.1446-.2124.062-.0608.1356-.109.2166-.1419.0809-.0329.1677-.0499.2554-.0499.0876 0 .1744.017.2553.0499.081.0329.1546.0811.2165.142l2.1031 2.0635c.062.0608.1112.1329.1447.2124.0336.0794.0509.1646.0509.2506s-.0173.1712-.0509.2506c-.0335.0795-.0827.1517-.1447.2125-.1251.1227-.2949.1917-.4719.1917-.1769 0-.3467-.069-.4718-.1917Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m13.1263 26.9666 15.7936-15.4961c.4404-.4322.4404-1.1326 0-1.56477-.4403-.43213-1.1543-.43213-1.5947 0L11.5315 25.402c-.4404.432-.4404 1.1326 0 1.5647.4404.432 1.1544.4319 1.5948-.0001Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Announcement.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Announcement"
};
validateTidalLicense();
export {
  Announcement
};
//# sourceMappingURL=Announcement.js.map
